<app-customer *ngIf="showCustomerLanding"></app-customer>
<app-loader></app-loader>
<main class="auto-height">
    <router-outlet></router-outlet>
</main>


